import { render, staticRenderFns } from "./FormSendCode.vue?vue&type=template&id=77ad2764"
import script from "./FormSendCode.vue?vue&type=script&lang=js"
export * from "./FormSendCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports